// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"98bb951f","295":"3096711e","416":"422974a3","495":"19b385d6","502":"dec4c112","543":"c842e5bd","599":"9b9b4b47","671":"8986be5f","896":"2c740b21"}[chunkId] + ".chunk.css";
};